import 'semantic-ui-css/semantic.min.css';
import { observer } from 'mobx-react-lite';
import {
  Dropdown,
  Form,
  Grid,
  Segment,
  Tab,
  Image,
  Button,
  Icon,
  Header,
  Checkbox,
  Input,
} from 'semantic-ui-react';
import { store, useStore } from '../../../app/stores/store';
import { SyntheticEvent, useEffect, useRef, useState } from 'react';
import {
  optionsInterface,
  tabVerifyData,
  VerifyInterface,
} from '../../../app/models/tabverify';
import { elemOptions } from '../../../app/common/options/dashboardOptions/TabVerifyOptions';
import CameraModal from '../../../app/common/modals/CameraModal';
import { FileUploadInterface } from '../../../app/models/Profile';
import VerifyFileUpload from './VerifyImageUpload/VerifyFileUpload';
import { TabDummy } from './TabDummy';
import DashboardWorkLevel from './DashboardWorkLevel';
import VerifySaveFunction from './VerifySaveFunction';
import agent from './../../../app/api/agent';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';
import ImageTag from '../../../features/Profile/RenderImage';
import { User } from '../../../app/models/user';

const sampleImageArray = [
  '/assets/thumbnail.png',
  '/assets/thumbnail.png',
  '/assets/thumbnail.png',
];
function DashboardTabVerify() {
  const {
    TemplateStore,
    dashboardStore: {
      dashboard,
      tagCount,
      setOpenCameraModal,
      setcamImageBase64,
      setVerifyUrlResponse,
      setRegisterUrlResponse,
    },
    WorkLevelStore,
    activityStore,
    commonStore,
    userStore,
    metaDataStore,
  } = useStore();

  const {
    loadCloneData,
    itemClonedDatas,
    setCurrentTabVerify,
    currentTabVerify,
  } = WorkLevelStore;
  const {
    assetTypeRegistry,
    loadAssetTypes,
    assetTypesByName,
    loadAssetTypeById,
    selectedAssetType,
    elementTypesRegistry,
    loadElementTypes,
  } = TemplateStore;
  const [selectedAssetTypeId, setSelectedAssetTypeId] = useState<string[]>([]); //parent selection
  const [elementTypeOptions, setElementTypeOptions] = useState<
    optionsInterface[] | []
  >([]);
  const [selectedElementTypeId, setSelectedElementTypeId] = useState<string[]>(
    [],
  ); //child selection
  //child
  const [selectedChildPane, setSelectedChildPane] = useState<VerifyInterface>();
  const [subChildObj, setSubChildObj] = useState<VerifyInterface[]>([]);

  const [elementData, setElementData] = useState<string>(''); //number of elem data
  const [ftpPath, setFtpPath] = useState<string>('');
  const [cloneCheckBox, setCloneCheckbox] = useState<boolean>(false);
  const [photosArr, setPhotosArr] = useState<FileUploadInterface[]>([]); //images
  //index
  const [parentActiveIndex, setparentActiveIndex] = useState<number>(0);
  const [childActiveIndex, setChildActiveIndex] = useState<number>(0);
  //image
  const [fileUrl, setFileUrl] = useState<FileUploadInterface[]>([]);
  //Film TITLe

  const [openCamera, setCameraOpen] = useState(false);
  const isExist = useRef(true);

  // const [isFilmFestival,setIsFilmFestival]=useState(false);

  const [usersList, setUsersList] = useState<User[]>([]);

  // const closeCamera = () => {
  //   setCameraOpen(false);
  // };

  const openCameraModal = () => {
    setOpenCameraModal(true);
    setCameraOpen(true);
  };

  useEffect(() => {
    const fetchUsers = async () => {
      const response = userStore.getUsers;
      setUsersList(response);
    };

    fetchUsers();
  }, [userStore.getUsers]);

  useEffect(() => {
    if (assetTypeRegistry.size <= 1) loadAssetTypes();
  }, [assetTypeRegistry.size, loadAssetTypes]);

  useEffect(() => {
    if (elementTypesRegistry.size <= 1) loadElementTypes();
  }, [elementTypesRegistry.size, loadElementTypes]);

  const assetTypeOptions = assetTypesByName
    .filter((y) => y.typeName !== 'Masters')
    .map((x) => ({
      key: x.id,
      text: x.typeName,
      value: x.id + '/' + x.typeName,
    }));

  useEffect(() => {
    if (selectedAssetType) {
      const elementTypeOptions2 = selectedAssetType?.elementTypes.map((x) => ({
        key: x.id,
        text: x.elementName,
        value:
          x.id +
          '/' +
          selectedAssetType.typeName +
          '/' +
          x.elementName +
          '/' +
          selectedAssetType.id,
      }));
      setElementTypeOptions(elementTypeOptions2);
    }
  }, [selectedAssetType]);

  /// it will fetch the cloned data and apply to particular pane
  useEffect(() => {
    const objIndex = subChildObj.findIndex(
      (obj) => obj.childPane === currentTabVerify.childPane,
    );
    //updating particular object value
    if (subChildObj.length > 0) {
      const clonedFromID = itemClonedDatas?.id;
      const newArr = { ...itemClonedDatas, cloned_From: clonedFromID };
      Object.assign(subChildObj[objIndex], newArr);
    }
    // eslint-disable-next-line
  }, [itemClonedDatas]);

  //for setting images
  useEffect(() => {
    if (selectedChildPane && dashboard.camImageUrl.length > 0) {
      const objIndex = subChildObj.findIndex(
        (obj) => obj.childPane === selectedChildPane.childPane,
      );
      subChildObj[objIndex].photos = dashboard.camImageUrl;
      const updateddata = (subChildObj[objIndex].photos =
        dashboard.camImageUrl);
      setPhotosArr(updateddata);
      setcamImageBase64([]);
    }
    // eslint-disable-next-line
  }, [dashboard.camImageUrl]);
  //for FIles
  useEffect(() => {
    if (selectedChildPane && dashboard.verifyImageUrl.length > 0) {
      const objIndex = subChildObj.findIndex(
        (obj) => obj.childPane === selectedChildPane.childPane,
      );
      subChildObj[objIndex].files = dashboard.verifyImageUrl;
      const updateddata = (subChildObj[objIndex].files =
        dashboard.verifyImageUrl);
      setFileUrl(updateddata);
    }
    // eslint-disable-next-line
  }, [dashboard.verifyImageUrl]);

  /////////////////////Child Functions
  ////////child Dropdown
  const handleClickChildDropdown = (e: any, data: any, a: string) => {
    if (a.split('/')[0].length > 0) {
      loadAssetTypeById(a.split('/')[0]);
    }
  };

  //for child Tab
  const handleChildTabChange = (e: SyntheticEvent, data: any) => {
    setChildActiveIndex(data.activeIndex); //child Active Index
    //value
    const value =
      e.currentTarget.textContent !== undefined &&
      e.currentTarget.textContent !== null
        ? e.currentTarget.textContent
        : '';
    const elemValue = subChildObj.filter((x) => x.childPane.includes(value));
    ////////////////////////////////////Checking existing value
    setCloneCheckbox(elemValue[0]?.isCloned);
    setElementData(elemValue[0]?.number_of_elem);
    setFtpPath(elemValue[0]?.ftpPath);
    setPhotosArr(elemValue[0]?.photos);
    setFileUrl(elemValue[0]?.files);
    setSelectedChildPane(elemValue[0]);

    setRegisterUrlResponse([]); //removing existing arr
    setVerifyUrlResponse([]); //removing existing arr
  };

  const handleFTPChange = async (e: any, data: any, a: VerifyInterface) => {
    metaDataStore
      .WorkflowMetadataHandler(a.childPane.split('/')[0])
      .then((Response) => {
        // const metaDataDetails =
        //   await agent.ElementTypes.getElementTypeMetaDataTemplate(
        //     a.childPane.split('/')[0],
        //   );
        setChildActiveIndex(childActiveIndex); //child Active Index
        setRegisterUrlResponse([]);
        setVerifyUrlResponse([]);
        const objIndex = subChildObj.findIndex(
          (obj) => obj.childPane === a.childPane,
        ); //updating particular object value
        subChildObj[objIndex].ftpPath = data.value;
        subChildObj[objIndex].metadata = Response ? Response : []; //setting for meta data
        setFtpPath(data.value);
        setPhotosArr(subChildObj[objIndex]?.photos); //setting data
        setFileUrl(subChildObj[objIndex]?.files); //setting data
        setSelectedChildPane(subChildObj[objIndex]); //setting data
      });
  };
  ////number of element data - handle Change
  const handleElementChange = async (e: any, data: any, a: VerifyInterface) => {
    metaDataStore
      .WorkflowMetadataHandler(a.childPane.split('/')[0])
      .then((Response) => {
        setChildActiveIndex(childActiveIndex); //child Active Index
        setRegisterUrlResponse([]);
        setVerifyUrlResponse([]);
        const objIndex = subChildObj.findIndex(
          (obj) => obj.childPane === a.childPane,
        ); //updating particular object value
        subChildObj[objIndex].number_of_elem = data.value;
        subChildObj[objIndex].metadata = Response ? Response : []; //setting for meta data
        setElementData(data.value);
        setPhotosArr(subChildObj[objIndex]?.photos); //setting data
        setFileUrl(subChildObj[objIndex]?.files); //setting data
        setSelectedChildPane(subChildObj[objIndex]); //setting data
      });

    // const metaDataDetails =
    //   await agent.ElementTypes.getElementTypeMetaDataTemplate(
    //     a.childPane.split('/')[0],
    //   );
    // const metaDataDetials= elementTypesRegistry.get(a.childPane.split('/')[0])?.metadata//checking for meta data
  };

  ///////////Clone Data
  const handleClone = (e: any, data: any, a: VerifyInterface) => {
    let title = `${store?.dashboardStore?.dashboard?.checkClikedWorkLevel
      .title} - ${dashboard.dashboardWorkLevelMaster.title} - ${
      a.childPane.split('/')[2]
    }`;
    let payload = {
      title,
      type: a.childPane.split('/')[1],
      element: a.childPane.split('/')[2],
    };
    loadCloneData(payload);
    setCurrentTabVerify(a);

    //updating the checkbox
    const objIndex = subChildObj.findIndex(
      (obj) => obj.childPane === a.childPane,
    ); //updating particular object value
    subChildObj[objIndex].isCloned = data.checked;
  };

  const childPaneTab = subChildObj
    ?.filter(
      (a: VerifyInterface) =>
        a?.parentPane?.includes(
          selectedAssetTypeId[parentActiveIndex]?.split('/')[1],
        ),
    )
    .map((a: VerifyInterface) => ({
      menuItem: a.childPane?.split('/')[2],
      render: () => (
        <Tab.Pane key={a.childPane.split('/')[0]}>
          <Checkbox
            label={
              (
                userLanguage[0].Level3InventoryRecievingVerify?.IRVCB01 as any
              )?.[`${commonStore.language.key}`]
            } //"Clone Existing Data"
            key={a.childPane.split('/')[0]}
            style={{
              marginTop: '10px',
              right: '10px',
              position: 'absolute',
            }}
            name={a.childPane.split('/')[0]}
            onChange={(e: any, data: any) => handleClone(e, data, a)}
            className="table-toggle"
            defaultChecked={cloneCheckBox}
            disabled={
              subChildObj[childActiveIndex].number_of_elem !== '' ? false : true
            }
          />

          <Form>
            <Form.Field>
              <label //Number of elements
              >
                {
                  (
                    userLanguage[0].Level3InventoryRecievingVerify
                      ?.IRVL04 as any
                  )?.[`${commonStore.language.key}`]
                }
              </label>
              <Dropdown
                key={a.childPane.split('/')[0]}
                name={a.childPane}
                placeholder={
                  (
                    userLanguage[0].Level3InventoryRecievingVerify
                      ?.IRVDD04 as any
                  )?.[`${commonStore.language.key}`]
                } //"Number of Elements"
                fluid
                selection
                onChange={(e: SyntheticEvent, data: any) =>
                  handleElementChange(e, data, a)
                }
                clearable
                options={elemOptions}
                value={elementData}
              />
              {a.childPane?.split('/')[2] === 'FTP' && (
                <Input
                  name={'FTP Path'}
                  placeholder={'Enter FTP Path'}
                  style={{ margin: '16px 0' }}
                  disabled={subChildObj[childActiveIndex].number_of_elem === ''}
                  value={ftpPath}
                  onChange={(e: SyntheticEvent, data: any) =>
                    handleFTPChange(e, data, a)
                  }
                />
              )}
              {a.childPane?.split('/')[2] !== 'FTP' && (
                <Segment>
                  <Grid>
                    {photosArr?.length > 0
                      ? photosArr.map((url) => {
                          return (
                            <Grid.Column
                              textAlign={'center'}
                              key={url.url}
                              width={2}
                            >
                              <ImageTag
                                imageUrl={url.url}
                                defaultUrl="/assets/documents.jpg"
                              />
                            </Grid.Column>
                          );
                        })
                      : sampleImageArray.map((e, i) => {
                          return (
                            <Image
                              key={i}
                              size="small"
                              src={e}
                              alt="/assets/documents.jpg"
                            />
                          );
                        })}
                  </Grid>
                </Segment>
              )}
            </Form.Field>
          </Form>
          {a.childPane?.split('/')[2] !== 'FTP' && (
            <Segment basic>
              <Button
                primary
                onClick={openCameraModal}
                disabled={
                  subChildObj[childActiveIndex].number_of_elem !== ''
                    ? false
                    : true
                }
                size="medium"
              >
                <Icon
                  name="camera retro"
                  size="large"
                  //Add Photographs
                />
                {
                  (
                    userLanguage[0].Level3InventoryRecievingVerify
                      ?.IRVB01 as any
                  )?.[`${commonStore.language.key}`]
                }
              </Button>
            </Segment>
          )}
          <div
            style={{
              pointerEvents:
                subChildObj[childActiveIndex].number_of_elem === ''
                  ? 'none'
                  : 'auto',
              opacity:
                subChildObj[childActiveIndex].number_of_elem === ''
                  ? '0.7'
                  : '1',
            }}
          >
            <VerifyFileUpload nameData={'verify'} />
          </div>

          {fileUrl?.length > 0 && (
            <Segment>
              <Grid>
                {fileUrl?.map((url) => {
                  return (
                    <Grid.Column textAlign={'center'} key={url.url} width={2}>
                      {url.url.includes('pdf') ? (
                        <Image
                          src={'/assets/documents.jpg'}
                          alt="/assets/documents.jpg"
                        />
                      ) : (
                        <ImageTag imageUrl={url?.url} />
                      )}
                    </Grid.Column>
                  );
                })}
              </Grid>
            </Segment>
          )}
          <br />
        </Tab.Pane>
      ),
    }));

  ///////////////////////////////////////////////////////////////  Parent ///////////////////////////////////////////
  const handleParentDropdown = (e: any, data: any) => {
    // "9a07049c-2e90-4143-8f2d-7fc894974189/Film Festival"
    setSelectedAssetTypeId(data.value); //parent
    if (e.target.parentElement.text !== undefined) {
      setSubChildObj(
        subChildObj.filter((x) => x.parentPane !== e.target.parentElement.text),
      );
      setSelectedElementTypeId(
        selectedElementTypeId.filter(
          (x) => x.split('/')[1] !== e.target.parentElement.text,
        ),
      );
    }
  };

  const handleParentTabChange = (e: SyntheticEvent, data: any) => {
    //child active index
    setChildActiveIndex(0);
    const value =
      e.currentTarget.textContent !== undefined &&
      e.currentTarget.textContent !== null
        ? e.currentTarget.textContent
        : '';
    const elemValue = subChildObj.filter((x) => x.childPane.includes(value));
    setCloneCheckbox(elemValue[0]?.isCloned);
    setElementData(elemValue[0]?.number_of_elem);
    setFtpPath(elemValue[0]?.ftpPath);
    setFileUrl(elemValue[0]?.files);
    setPhotosArr(elemValue[0]?.photos);
    const selectedData = selectedAssetTypeId[data.activeIndex].split('/')[0];

    setparentActiveIndex(data.activeIndex); //seting active index
    loadAssetTypeById(selectedData);
  };

  //////////////////dropdown parent//////////////////////

  const handleChildDropdown = (e: any, data: any) => {
    //for deleting
    if (e.target.parentElement.text !== undefined) {
      subChildObj.splice(
        subChildObj.findIndex(
          (a) => a.childPane.includes(e.target.parentElement.text),
          1,
        ),
      );
    }
    const filteredData = data.value.filter(
      (ele: string, ind: number) =>
        ind === data.value.findIndex((elem: string) => elem === ele),
    ); //filtering for already existing data
    const filterExistingSubChild = subChildObj.map(function (item) {
      return item['childPane'];
    });

    const finalFilter = filteredData.filter(
      (x: string) => !filterExistingSubChild.includes(x),
    );
    // eslint-disable-next-line
    finalFilter.map((x: string) => {
      const splitData = x.split('/');
      const newArr = {
        ...tabVerifyData,
        parentPane: splitData[1],
        childPane: x,
        number_of_elem: '',
        typeid: splitData[splitData.length - 1],
        photos: [],
        files: [],
        registerId: dashboard.checkClikedWorkLevel.id,
      };
      setSubChildObj([...subChildObj, newArr]);
    });

    setSelectedElementTypeId(filteredData);
  };

  ///////////end of film festival parent
  const panes = selectedAssetTypeId.map((a: string, index: number) => ({
    menuItem: a.split('/')[1],
    render: () => (
      <Tab.Pane key={a.split('/')[0]} style={{ minHeight: '500px' }}>
        <Dropdown
          key={index}
          placeholder={
            (userLanguage[0].Level3InventoryRecievingVerify?.IRVDD03 as any)?.[
              `${commonStore.language.key}`
            ]
          } //"Select Element"
          fluid
          selection
          multiple
          value={selectedElementTypeId}
          options={elementTypeOptions}
          onChange={handleChildDropdown}
          onClick={(e: SyntheticEvent, data: any) =>
            handleClickChildDropdown(e, data, a)
          }
        />
        <br />
        {/* childpane */}
        <Tab
          panes={childPaneTab}
          onTabChange={handleChildTabChange}
          activeIndex={childActiveIndex}
        />
      </Tab.Pane>
    ),
  }));
  const handleSave = async () => {
    new Promise(async (resolve) => {
      const response = await agent.WorkLevels.loadName(
        dashboard.dashboardWorkLevelMaster.id,
      );
      resolve(response);
    })
      .then(async (response) => {
        let subChildObjModify:VerifyInterface[] = []
        if(userStore.user?.customerName === 'PCPLCRM' && userStore?.user?.roleName.trim() === 'IT Team'){
          subChildObjModify = subChildObj.map(e=> {
            if(e.parentPane === 'IT Asset Tracking'){
              const companyIndex = e.metadata.findIndex(e => e.elementName === 'Company')
              const modelNoIndex = e.metadata.findIndex(e => e.elementName === 'Make Or Model No');
              const categoryIndex = e.metadata.findIndex(e =>  e.elementName === 'Category');
              if(companyIndex !== -1) e.metadata[companyIndex].elementValue = dashboard.checkClikedWorkLevel.senderDetails;
              if(modelNoIndex !== -1) e.metadata[modelNoIndex].elementValue = dashboard.checkClikedWorkLevel.title;
              if(categoryIndex !== -1) e.metadata[categoryIndex].elementValue = dashboard.dashboardWorkLevelMaster.title;
              return e;
            }
            else{
              return e;
            }
          })
        }
        else{
          subChildObjModify = subChildObj;
        }
        await VerifySaveFunction(
          subChildObjModify,
          response,
          undefined,
          dashboard.checkClikedWorkLevel.barcode_Package,
          usersList,
        );
        //reset values
        setSelectedAssetTypeId([]); //parent selection
        setElementTypeOptions([]);
        setSelectedElementTypeId([]); //child selection
        //child
        setSelectedChildPane(undefined);
        setSubChildObj([]);
        setElementData(''); //number of elem data
        setFtpPath('');
        setPhotosArr([]); //images
        setFileUrl([]);
      })
      .then(() => {
        setTimeout(() => {
          tagCount();
        }, 2000);
      })
      .then(() => {
        setTimeout(() => {
          activityStore.loadTagPagination(dashboard.setTagTablePageNumber);
        }, 2000);
      });
  };

  let disabledCondition = true;

  useEffect(() => {
    isExist.current = true;
    for (let i = 0; i < selectedAssetTypeId.length; i++) {
      if (!isExist.current) break;
      let count = 0;
      for (let j = 0; j < selectedElementTypeId.length; j++) {
        if (
          selectedElementTypeId[j].split('/')[1] !==
          selectedAssetTypeId[i].split('/')[1]
        ) {
          count += 1;
        }
      }
      if (count === selectedElementTypeId.length) {
        isExist.current = false;
      }
    }
    //eslint-disable-next-line
  }, [selectedAssetTypeId, selectedElementTypeId]);

  disabledCondition =
    subChildObj.filter((x) => x.number_of_elem === '').length > 0;

  return (
    <Segment
      className={
        dashboard.onFirstLoadNoTransition
          ? ''
          : dashboard.setfadeIn
            ? 'fadeIn'
            : 'fadeOut'
      }
      style={{ marginTop: '10px', height: '61.7vh', overflowY: 'scroll' }}
    >
      <Header
        size="huge"
        dividing
        as="h1"
        icon="check"
        content={
          userStore?.user?.customerName === 'Lok Sabha'
            ? 'Inspection'
            : (userLanguage[0].Level3InventoryRecievingVerify?.IRVL01 as any)?.[
                `${commonStore.language.key}`
              ]
        } //"Verify"
        sub
        color="grey"
      />
      {dashboard.openCameraModal && openCamera && (
        <CameraModal nameData="verify" />
      )}
      {dashboard.checkClikedWorkLevel.title?.length === 0 ? (
        <div style={{ marginTop: '10px' }}>
          <div
            style={{
              alignItems: 'center',
              display: 'block',
              margin: 'auto',
            }}
          >
            <p
            //Please select item received
            >
              {
                (
                  userLanguage[0].Level3InventoryRecievingVerifyTab
                    ?.IRVTL01 as any
                )?.[`${commonStore.language.key}`]
              }
            </p>
            <br />
          </div>
        </div>
      ) : (
        <>
          <Form style={{ marginTop: '5px' }}>
            <Grid stackable>
              <Grid.Row stretched columns={1}>
                <Grid.Column>
                  <DashboardWorkLevel
                    isFilmFestival={dashboard.isFilmFestival}
                  />
                </Grid.Column>
              </Grid.Row>

              <Grid.Row stretched columns={1}>
                <Grid.Column>
                  <Dropdown
                    placeholder={
                      (
                        userLanguage[0].Level3InventoryRecievingVerify
                          ?.IRVDD02 as any
                      )?.[`${commonStore.language.key}`]
                    } //"Select Type"
                    fluid
                    selection
                    multiple
                    style={{
                      pointerEvents: dashboard.isFilmFestival ? 'none' : 'auto',
                    }}
                    // disabled
                    options={assetTypeOptions}
                    onChange={handleParentDropdown}
                    value={selectedAssetTypeId}
                  />
                  <br />
                  {selectedAssetTypeId.length === 0 ? (
                    <TabDummy />
                  ) : (
                    <Tab
                      panes={panes}
                      onTabChange={handleParentTabChange}
                      activeIndex={parentActiveIndex}
                      style={{ minHeight: '500px' }}
                    />
                  )}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Form>
          <br />
          <Button
            primary
            onClick={handleSave}
            disabled={
              disabledCondition ||
              !isExist.current ||
              selectedElementTypeId.length <= 0 ||
              selectedAssetTypeId.length <= 0
              // (selectedElementTypeId.length <= 0 &&
              // selectedAssetTypeId.length <= 0) ||
              // !(isExist.current) || disabledCondition
            }
            className="dashboard-tabverify-button"
            //Save
          >
            {
              (userLanguage[0].Level3InventoryRecievingVerify?.IRVB05 as any)?.[
                `${commonStore.language.key}`
              ]
            }
          </Button>
        </>
      )}
    </Segment>
  );
}
export default observer(DashboardTabVerify);

//style={{width: "100%",overflowX: "scroll"}}
